import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { EventService, Product } from '@spartacus/core';
import {
  CustomProductSelectedEvent
} from "src/app/spartacus/features/tracking/custom-events/product/custom-product-page.events";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: 'app-custom-product-item',
  templateUrl: './custom-product-item.component.html',
  styleUrls: ['./custom-product-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomProductItemComponent implements OnInit {
  @Input() item: Product;
  @Input() pdp: boolean;

  constructor(protected eventService: EventService,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
  }

  onSelectItem(item: Product, event) {
    if (item) {
      event.stopPropagation();
    }
    const urlParams = this.activatedRoute.snapshot.params;
    this.eventService.dispatch({ product: item, activateRouteParams: urlParams }, CustomProductSelectedEvent);
  }
}
